import { render, staticRenderFns } from "./SavingDeCompras.vue?vue&type=template&id=6c709af8&scoped=true"
import script from "./SavingDeCompras.vue?vue&type=script&lang=js"
export * from "./SavingDeCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c709af8",
  null
  
)

export default component.exports